import exceljs from "exceljs";
import { saveAs } from "file-saver";
import { useMyStore } from "src/components/main/mainStore";
import { 
    changeWeek, 
    numberReducer, 
    mimeTypeMap, 
} from "src/components/common/functions";

export default function Export({
    week, 
    weeks, 
    laborCosts, 
    projects, 
    importedBillings, 
    oh
}){
    const user = useMyStore(state => state.user);
    const generateExcel = async() => {
        // const formData = new MyFormData();
        // const resAllBillings = await myAxios("profitMargin/readAllBillings.php", formData);
        // const allBillings = resAllBillings.data; // work with laborCosts
        const week1 = changeWeek(week, -1);
        const week2 = changeWeek(week, -2);
        const weekArr = [week, week1, week2];
        const obj = {};
        weekArr.forEach((curWeek, weekIndex) => {
            if(curWeek in laborCosts){
                Object.keys(laborCosts[curWeek]).forEach(projectHashKey => {
                    if(!(projectHashKey in obj)){
                        obj[projectHashKey] = {};
                        obj[projectHashKey].index = weekIndex;
                        obj[projectHashKey].name = projects.find(project => project.value === projectHashKey).label;
                        // obj[projectHashKey].billings = allBillings.filter(billing => projectHashKey === billing.projectHashKey).map(billing => window.parseFloat(billing.amount)).reduce((a, b) => (a + b), 0);
                        obj[projectHashKey].billings = weeks.map(wk => importedBillings[wk]?.[projectHashKey]?.map(item => item.amount).reduce(numberReducer, 0) ?? 0).reduce((a, b) => (a + b), 0);
                        obj[projectHashKey].laborCosts = weeks.map(wk => laborCosts[wk]?.[projectHashKey] ?? 0).reduce((a, b) => (a + b), 0);
                        obj[projectHashKey].oh = obj[projectHashKey].laborCosts * (window.parseFloat(oh || "1.54"));
                        obj[projectHashKey].totalCosts = obj[projectHashKey].oh + obj[projectHashKey].laborCosts;
                        obj[projectHashKey].profit = obj[projectHashKey].billings - obj[projectHashKey].totalCosts;
    
                        obj[projectHashKey].billings = Math.round(obj[projectHashKey].billings);
                        obj[projectHashKey].laborCosts = Math.round(obj[projectHashKey].laborCosts);
                        obj[projectHashKey].oh = Math.round(obj[projectHashKey].oh);
                        obj[projectHashKey].totalCosts = Math.round(obj[projectHashKey].totalCosts);
                        obj[projectHashKey].profit = Math.round(obj[projectHashKey].profit);
                    }
                })
            }
        })
        const data = Object.values(obj);
        // generate Excel
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        //-------------------------------------------------------------------------------------------
        const data0 = data.filter(post => post.index === 0);
        // if(!data0.length){
        //     window.alert("No Active Projects for selected week.");
        //     return;
        // }
        const worksheet0 = workbook.addWorksheet("Active Projects", {views: [{showGridLines: false}]});
        worksheet0.state = "visible";
        worksheet0.properties.defaultColWidth = 22.57;
        const rows0 = data0.map(post => [
            post.name, 
            post.billings, 
            post.laborCosts, 
            post.oh,
            post.totalCosts,
            post.profit,
            post.billings > 0 ? (post.profit / post.billings) : "N/A"
        ])
        worksheet0.addTable({
            name: "MyTable1",
            ref: "A1",
            totalsRow: true,
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "Project Name", filterButton: true},
                { name: "Billing", filterButton: true, totalsRowFunction: "sum"},
                { name: "Labor Cost", filterButton: true, totalsRowFunction: "sum"},
                { name: "Overhead", filterButton: true, totalsRowFunction: "sum"},
                { name: "Total Cost", filterButton: true, totalsRowFunction: "sum"},
                { name: "Profit", filterButton: true, totalsRowFunction: "sum"}, 
                { name: "Profit Margin", filterButton: true, totalsRowFunction: "sum"}
            ],
            rows: rows0,
        });
        worksheet0.getColumn(7).eachCell(cell => {
            cell.numFmt = "0.00%";
        })
        worksheet0.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                // exclude row 1 - ---------
                if(cell.row === 1) return;
                //-------------------------
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.3)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        worksheet0.addConditionalFormatting({
            ref: `F2:F${data0.length + 2}`,
            rules: [
                {
                    type: 'cellIs',
                    operator: 'greaterThan',
                    formulae: [0],
                    style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'C6EFCE'}}, font: {color: {argb: "007B53"}}},
                },
                {
                    type: 'cellIs',
                    operator: 'lessThan',
                    formulae: [0],
                    style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'FFC7CE'}}, font: {color: {argb: '9C0006'}}},
                }
            ]
        });
        worksheet0.addConditionalFormatting({
            ref: `G2:G${data0.length + 2}`,
            rules: [
                {
                    type: 'cellIs',
                    operator: 'greaterThan',
                    formulae: [0],
                    priority: 2, 
                    style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'C6EFCE'}}, font: {color: {argb: "007B53"}}},
                },
                {
                    type: 'cellIs',
                    operator: 'lessThan',
                    formulae: [0],
                    style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'FFC7CE'}}, font: {color: {argb: '9C0006'}}},
                },
                {
                    type: 'containsText',
                    operator: 'containsText',
                    text: 'N/A',
                    priority: 1, 
                    style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'FFFFFF'}}, font: {color: {argb: '000000'}}},
                }
            ]
        });
        //-------------------------------------------------------------------------------------------
        const data1 = data.filter(post => post.index !== 0);
        if(data1.length){
            const worksheet1 = workbook.addWorksheet("Completed Projects", {views: [{showGridLines: false}]});
        worksheet1.state = "visible";
        worksheet1.properties.defaultColWidth = 22.57;
            const rows1 = data1.map(post => [
                post.name, 
                post.billings, 
                post.laborCosts, 
                post.oh,
                post.totalCosts,
                post.profit,
                post.billings > 0 ? (post.profit / post.billings) : "N/A"
            ])
            worksheet1.addTable({
                name: "MyTable2",
                ref: "A1",
                totalsRow: true,
                style: {
                    showRowStripes: true,
                },
                columns: [
                    { name: "Project Name", filterButton: true},
                    { name: "Billing", filterButton: true, totalsRowFunction: "sum"},
                    { name: "Labor Cost", filterButton: true, totalsRowFunction: "sum"},
                    { name: "Overhead", filterButton: true, totalsRowFunction: "sum"},
                    { name: "Total Cost", filterButton: true, totalsRowFunction: "sum"},
                    { name: "Profit", filterButton: true, totalsRowFunction: "sum"},
                    { name: "Profit Margin", filterButton: true}
                ],
                rows: rows1,
            });
            worksheet1.getColumn(7).eachCell(cell => {
                cell.numFmt = "0.00%";
            })
            worksheet1.columns.forEach(column => {
                const minLength = 18;
                let maxLength = 0;
                column["eachCell"]({ includeEmpty: true }, cell => {
                    // exclude row 1 - ---------
                    if(cell.row === 1) return;
                    //-------------------------
                    const columnLength = cell.value?
                    cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1.3)
                    :minLength;
                    if(columnLength > maxLength){
                        maxLength = columnLength;
                    }
                });
                column.width = maxLength < minLength ? minLength : maxLength;
            });
            worksheet1.addConditionalFormatting({
                ref: `F2:F${data1.length + 2}`,
                rules: [
                    {
                        type: 'cellIs',
                        operator: 'greaterThan',
                        formulae: [0],
                        style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'C6EFCE'}}, font: {color: {argb: "007B53"}}},
                    },
                    {
                        type: 'cellIs',
                        operator: 'lessThan',
                        formulae: [0],
                        style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'FFC7CE'}}, font: {color: {argb: '9C0006'}}},
                    }
                ]
            });
            worksheet1.addConditionalFormatting({
                ref: `G2:G${data0.length + 2}`,
                rules: [
                    {
                        type: 'cellIs',
                        operator: 'greaterThan',
                        formulae: [0],
                        priority: 2, 
                        style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'C6EFCE'}}, font: {color: {argb: "007B53"}}},
                    },
                    {
                        type: 'cellIs',
                        operator: 'lessThan',
                        formulae: [0],
                        style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'FFC7CE'}}, font: {color: {argb: '9C0006'}}},
                    },
                    {
                        type: 'containsText',
                        operator: 'containsText',
                        text: 'N/A',
                        priority: 1, 
                        style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'FFFFFF'}}, font: {color: {argb: '000000'}}},
                    }
                ]
            });
        }
        //-------------------------------------------------------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `profit export for ${week}.xlsx`);
        })  
    }
    return(
        <span className = "btn btn-primary ml-2" onClick = {generateExcel}>Generate Excel</span>
    );
}